import { useQuery } from '@tanstack/react-query'
import { PartnerService } from '@duck/api-definitions'
import { apis } from '@/modules/apiClients'
import { useAuth } from './useAuth'

export const partnerDashboardQueryKeys = {
  all: () => ['partner-dashboard'] as const,
  user: () => ['partner-dashboard', 'user'] as const
}

const fetchPartnerDashboard = async (): Promise<PartnerService.PartnerDashboardResponse> => {
  const response = await apis.partnerService.partnerDashboardGet()
  return response.data
}

export const usePartnerDashboard = () => {
  const { isPartner } = useAuth()
  const query = useQuery({
    queryKey: partnerDashboardQueryKeys.user(),
    queryFn: fetchPartnerDashboard,
    enabled: isPartner,
    staleTime: 5 * 60 * 1000, // 5 minutes - dashboard data can change frequently
  })

  return {
    recentAssignments: query.data?.recentAssignments ?? [],
    isLoading: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  } as const
}

